<template>
  <button ref="ladda" class="ladda-button" :data-style="dataStyle">
    <span class="ladda-label"><slot>Submit</slot></span>
  </button>
</template>

<script>
import * as Ladda from 'ladda'
import 'ladda/css/ladda.scss'
export default {
  name: 'VueLadda',
  props: {
    dataStyle: {
      type: String,
      default: 'zoom-out'
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      ladda: null
    }
  },
  watch: {
    loading(loading) {
      loading ? this.ladda.start() : this.ladda.stop()
    }
  },
  mounted() {
    this.ladda = Ladda.create(this.$refs.ladda)
    this.loading ? this.ladda.start() : this.ladda.stop()
  },
  beforeDestroy() {
    this.ladda.remove()
    this.ladda = null
  }
}
</script>
